<template>
	<div id="login">
		<div class="col-12 col-lg-4 lateral">
			<Logo/>
			<v-form ref="form_usuario">
				<div class="row">
					<div class="col-12">
						<h2>
							Olá! Seja bem-vindo(a)
						</h2>
					</div>
					<div class="col-12">
							<v-text-field type="email" :rules="[v => !!v || 'Campo obrigatório']" v-model="input.email" label="Usuário" placeholder="Usuário" outlined/>
					</div>
					<div class="col-6 offset-6 recuperar-senha">
						<router-link to="/login">Voltar</router-link>
					</div>
					<div class="col-12">
						<v-btn type="submit" block elevation="2" large color="primary" :loading="loading" >
							Enviar
						</v-btn>
					</div>
				</div>
			</v-form>
		</div>
		<div class="col-8 imagem background animated">
			<LateralLogin/>
		</div>
		<Loader v-if="loading"/>
	</div>
</template>

<script>
	import Logo from "@/components/Logo.vue"
	import LateralLogin from "@/components/LateralLogin.vue"
	import Loader from "@/components/Loader.vue"
	import store from '@/store'
	
	export default {
		name: 'RecuperarSenha',
		components: {
			Logo,
			Loader,
			LateralLogin
		},
		data() {
            return {
				loading: false,
                input: {
                    email: ""
                },
                validacao: {
                    email: false
                }
            }
        },
        methods: {
			changeLoading(value) {
				this.loading = value
			},
			handleSubmit() {
				this.changeLoading(true)
                if(this.input.email != "") {
					store.dispatch('recuperarSenha', this.input).then(()=>{
						this.changeLoading(false)
						this.validacao.email = false
					})
                } else {
					this.changeLoading(false)
                    this.validacao.email = true
                }
            }
        }
	}
</script>

<style lang="scss">
	#login{
		flex: 1;
		display: flex;
		max-height: 100vh;
		.lateral{
			form{
				padding: 50px;
				h2{					
					font-style: normal;
					font-weight: 500;
					font-size: 22px;
					line-height: 36px;
					color: $primarycolor;
				}
				.lembrar-usuario{
					display: flex;
					align-items: center;
					label{
						display: flex;
						align-items: center;
						margin-bottom: 0;
						p{
							padding: 0px;
							font-style: normal;
							font-weight: normal;
							font-size: 14px;
							line-height: 17px;
							color: #373737;
						}
						input{
							width: auto;
							margin-right: 10px;
						}
					}
				}
				.recuperar-senha{
					display: flex;
					align-items: center;
					justify-content: flex-end;
					text-align: right;
					a{
						text-align: right;
						font-style: normal;
						font-weight: normal;
						font-size: 16px;
						line-height: 20px;
						color: rgba(0,0,0,.6);
					}
				}
				@media (max-width: 1400px){
					padding: 0 15px;
				}
			}
		}
		.imagem{
			flex: 1;
		}
	}
</style>